import React from 'react';
import { Box, Typography, TextField } from '@material-ui/core';
import { useMobileStyles } from '../styles';
import I18n from '../../../../localization';

const DeviceNameInput = ({
  iqAirDetails,
  onNameChange,
  IQAirNameError,
  label,
  maxLength = 40,
  disabled = false,
  inputId = 'iqAirName',
  useCardWithLabel = true,
  isEditScene
}) => {
  const classes = useMobileStyles();
  const inputCardClass = useCardWithLabel ? classes.IQCard : classes.pedding_bottom;
  const containerClassName = useCardWithLabel ? classes.cardWithLabel : [classes.IQCard, classes.IQAirMode, classes.InnerCards].join(" ");

  return (
    <div className={containerClassName}>
      <Typography className={isEditScene ? classes.cardInnerLabel : classes.cardCaption}>{label || I18n.t('mobile.iqAirSetting.iqAirName')}</Typography>
      <Box className={inputCardClass}>
        <TextField
          type="text"
          id={inputId}
          inputProps={{ maxLength }}
          value={iqAirDetails.name}
          className={classes.inputField}
          onChange={onNameChange}
          disabled={disabled}
        />
        {IQAirNameError.status && (
          <p className={classes.errorMsg}>{IQAirNameError.message}</p>
        )}
      </Box>
    </div>
  );
};

export default DeviceNameInput;
